export default {
  computed: {
    getActivePage() {
      return +this.$route.query.page || 1;
    }
  }
};
